import { SessionFilters } from 'components/table/SessionFilters';
import { Filter } from 'components/table/FilterType';

export const defaultPreferences = {
  gameDate: {
    id: SessionFilters.GameDate,
    chipDescription: `Period between:`,
    value: '',
    onRemove: () => {},
    type: Filter.DateRange,
    active: true,
  },
  venue: {
    id: SessionFilters.Venue,
    chipDescription: `Venue:`,
    value: '',
    onRemove: () => {},
    type: Filter.Textfields,
    active: true,
  },
  field: {
    id: SessionFilters.Field,
    chipDescription: 'Field:',
    value: '',
    onRemove: () => {},
    type: Filter.Textfields,
    active: true,
  },
  homeTeam: {
    id: SessionFilters.HomeTeam,
    chipDescription: 'Home Team:',
    value: '',
    onRemove: () => {},
    type: Filter.Textfields,
    active: true,
  },
  awayTeam: {
    id: SessionFilters.AwayTeam,
    chipDescription: 'Away Team:',
    value: '',
    onRemove: () => {},
    type: Filter.Textfields,
    active: true,
  },
};
